import { useQueryClient } from '@tanstack/react-query'

import {
    ClientInvitationDto,
    CreateClientInvitationDto,
    getAllClientInvitations,
    getAllClientInvitationsQueryKey,
    useCreateClientInvitation as useCreateClientInvitationTQ,
} from '@/gen/publicApi'

import { useToast } from '@/components/toast/useToast'

const useCreateClientInvitation = (clientCode: string, onSuccess: (apiKey: ClientInvitationDto) => void) => {
    const { toast } = useToast()
    const queryClient = useQueryClient()
    const createInvitationMutator = useCreateClientInvitationTQ(clientCode)

    const onCreate = (values: CreateClientInvitationDto) => {
        const listKey = getAllClientInvitationsQueryKey(clientCode)
        createInvitationMutator.mutate(values, {
            onSettled: async () => {
                const updatedInvitations = await getAllClientInvitations(clientCode)
                queryClient.setQueryData(listKey, updatedInvitations)
            },
            onError: err => {
                console.error('Failed to invite usser', err)
                toast({
                    variant: 'destructive',
                    title: 'Invitation creation failed!',
                    description: `Could not invite user, please try again`,
                })
            },
            onSuccess: data => {
                onSuccess(data)
            },
        })
    }

    return { onCreate, isPending: createInvitationMutator.isPending, data: createInvitationMutator.data }
}

export default useCreateClientInvitation
